<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-card
        elevation="5"
        v-bind:width="$vuetify.breakpoint.xs ? undefined : 500"
      >
        <div class="d-flex flex-column align-center pt-6 pb-2">
          <img
            v-bind:src="appOwnerLogo || '/favicon.png'"
            alt="logo"
            style="width:48px;height:48px;object-fit:contain"
          />
          <div class="text-h6 font-weight-bold mt-3">EVPN Manager</div>
          <div class="caption text--secondary">{{ appOwner }}<template v-if="appVersion"> — v{{ appVersion }}</template></div>
        </div>
        <v-card-text class="pt-4">
          <v-text-field
            label="Username"
            v-bind:rules="[rules.required]"
            v-model="username"
            autofocus
            outlined
          />

          <v-text-field
            label="Password"
            v-bind:append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:rules="[rules.required]"
            v-bind:type="showPwd ? 'text' : 'password'"
            v-model="password"
            v-on:keydown.enter="login"
            v-on:click:append="showPwd = !showPwd"
            outlined
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text v-on:click="login"> Login </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",

  data: () => ({
    showPwd: false,
    appVersion: process.env.VUE_APP_VERSION || "",
    username: process.env.VUE_APP_LOGIN_USERNAME || "",
    password: process.env.VUE_APP_LOGIN_PASSWORD || "",
    rules: {
      required: value => !!value || "Mandatory field"
    }
  }),

  mounted() {
    this.session_loggedIn = false;
    this.$server.execute({ url: "users/logout" });
  },

  methods: {
    login() {
      this.$server
        .send(
          {
            url: "/users/login",
            data: {
              username: this.username,
              password: this.password
            }
          },
          error => {
            if (error.status && error.status == 400) {
              this.$alert.raiseError("Invalid username or password");
            } else {
              this.$alert.raiseHttpError(error);
            }
            return true;
          }
        )
        .then(() => this.$server.query({ url: "users/logged" }))
        .then(data => {
          this.session_loggedUser = data;
          this.$router.replace({ path: "/main" });
        });
    }
  }
};
</script>
